

















import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class ToggleSwitch extends Vue {
  @Prop() id!: string
  @Prop() firstValue!: boolean

  mounted () {
    this.isChecked = this.firstValue
  }

  isChecked: boolean = false

  get computedIsChecked () {
    return this.isChecked
  }

  inputClick () {
    // @ts-ignore
    this.$refs.input.click()
  }

  handleChange () {
    this.isChecked = !this.isChecked
    this.$emit('changed', this.isChecked)
  }
}
